export default __webpack_public_path__ + "static/media/img_download_appstore.18d0ae97.svg";